import { createContext } from 'react';
import { UserProfile } from '../model';
import { IAppSettings } from 'model/common/app-settings';

export const UserProfileContext = createContext<UserProfile | null>(null);
export const AppSettingsContext = createContext<IAppSettings | null>(null);
